import { useMutation } from '@tanstack/react-query';
import { axios } from '@src/lib/axios';

const acceptTermsAndConditions = ({ privacyAndPolicy, termsAndCondition, serviceQualityWaiver }) => {
    return axios.post('/users/update-terms-and-agreement', {
        privacyAndPolicy,
        termsAndCondition,
        serviceQualityWaiver
    });
};

export const useAcceptTermsAndConditions = () => {
    return useMutation({
        mutationFn: attributes => {
            return acceptTermsAndConditions(attributes);
        }
    });
};

const subscribeToSms = ({ smsConsent, phoneNumber }) => {
    return axios.post('/users/sms-consent-and-contact', {
        smsConsent,
        phoneNumber
    });
};

export const useSubscribeToSms = () => {
    return useMutation({
        mutationFn: attributes => {
            return subscribeToSms(attributes);
        }
    });
};
